import { QUESTION_CSS_VARIABLES } from '@doltech/utils/lib/constants';
import styled from 'styled-components';

export const TestResultDesktopTheme = styled.div`
  ${QUESTION_CSS_VARIABLES.QUESTION_CIRCLE_LR_PADDING}: 12px;
`;
